<div class="pageheader">
  <div class="page-title">
    <h1>Document types</h1>
    <div class="btn-group">
      <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
      <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Document types log'">
        <app-change-log-link-entity type="DocumentType"></app-change-log-link-entity>
      </app-change-log-link>
    </div>
  </div>
</div>

<dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='documentTypes' [bizSetAllowColumnReordering]="false" [bizSetPager]="false" (onInitNewRow)="onInitNewRow($event)"
  (onRowInserting)="onRowInserting($event)" (onRowUpdating)="onRowUpdating($event)" (onRowRemoving)="onRowRemoving($event)" [bizEditRowOnDoubleClick]="true">

  <dxo-editing mode="popup" [allowUpdating]="allowUpdating" [allowAdding]="allowAdding" [allowDeleting]="allowDeleting">
    <dxo-popup title="Document type" [showTitle]="true"></dxo-popup>

    <dxo-form colCount="1">
      <dxi-item itemType="group" colCount="2">
        <dxi-item dataField="Name"></dxi-item>
        <dxi-item dataField="DocumentTypeGroupId"></dxi-item>
        <dxi-item dataField="Description" colSpan="2"></dxi-item>
        <dxi-item dataField="UsableForDistributions"></dxi-item>
        <dxi-item dataField="CdmStylesheetArtifactId"></dxi-item>
        <dxi-item dataField="CdmEmbeddedFileDataXPath"></dxi-item>
        <dxi-item dataField="CdmEmbeddedFileNameXPath"></dxi-item>
      </dxi-item>
      <dxi-item caption="Saved files" captionTemplate="savedFilesTemplate" itemType="group" colCount="2">
        <dxi-item dataField="LightTrackingOptions.TrackMessageIn"><dxo-label template="messageIn"></dxo-label></dxi-item>
        <dxi-item dataField="LightTrackingOptions.TrackCdm"></dxi-item>
        <dxi-item dataField="LightTrackingOptions.TrackInterchangeOut"></dxi-item>
      <!-- These are ready for use, but not yet enabled in the UI
        <dxi-item dataField="LightTrackingOptions.TrackAdditionalFilesForDocument"></dxi-item>
        <dxi-item dataField="LightTrackingOptions.TrackAdditionalFilesForInterchangeOut"></dxi-item>
      -->
      </dxi-item>

      <ng-container *dxTemplate="let data of 'savedFilesTemplate'">
        <div>
          <p class="dx-form-group-caption">{{data.caption}}</p>
          <p class="small">Excluding these files reduces the required storage space but may limit the ability to resend documents and troubleshoot issues.</p>
        </div>
      </ng-container>

      @for (label of labelTemplates; track label.name) {
        <ng-container *dxTemplate="let data of label.name">
          <span title="{{label.title}}" class="dx-field-item-label-text"><i class="dx-icon {{ label.icon }}"></i>{{data.text}}</span>
        </ng-container>
      }
    </dxo-form>
  </dxo-editing>

  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

  <dxi-column dataField="Name" caption="Name" dataType="string" sortOrder="asc">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="DocumentTypeGroupId" caption="Group" dataType="number">
    <dxi-validation-rule type="required"></dxi-validation-rule>
    <dxo-lookup [dataSource]="documentTypeGroups" valueExpr="DistributionObjectGroupId" displayExpr="Name"></dxo-lookup>
  </dxi-column>

  <dxi-column dataField="UsableForDistributions" caption="For distributions" dataType="boolean" [allowFiltering]="false"></dxi-column>

  <dxi-column dataField="Description" caption="Description" dataType="string" [allowFiltering]="false" [allowGrouping]="false">
    <dxi-validation-rule type="required"></dxi-validation-rule>
  </dxi-column>

  <dxi-column dataField="CdmStylesheetArtifactId" caption="Stylesheet" dataType="string" [allowFiltering]="false" [allowGrouping]="false" cellTemplate="stylesheetCellTemplate"
    editCellTemplate="stylesheetEditTemplate" alignment="center"></dxi-column>

  <dxi-column dataField="CdmEmbeddedFileDataXPath" caption="CDM embedded file data XPath" dataType="string" [allowFiltering]="false" [visible]="false" editCellTemplate="editXPathTemplate"></dxi-column>
  <dxi-column dataField="CdmEmbeddedFileNameXPath" caption="CDM embedded file name XPath" dataType="string" [allowFiltering]="false" [visible]="false" editCellTemplate="editXPathTemplate"></dxi-column>

  <dxi-column dataField="LightTrackingOptions.TrackMessageIn" caption="Message In" dataType="boolean" [visible]="false"></dxi-column>
  <dxi-column dataField="LightTrackingOptions.TrackCdm" caption="CDM" dataType="boolean" [visible]="false"></dxi-column>
  <dxi-column dataField="LightTrackingOptions.TrackInterchangeOut" caption="Interchange Out" dataType="boolean" [visible]="false"></dxi-column>
<!-- These are ready for use, but not yet enabled in the UI
  <dxi-column dataField="LightTrackingOptions.TrackAdditionalFilesForDocument" caption="Additional Files for Document" dataType="boolean"
    [visible]="false"></dxi-column>
  <dxi-column dataField="LightTrackingOptions.TrackAdditionalFilesForInterchangeOut" caption="Additional Files for Interchange Out" dataType="boolean"
    [visible]="false"></dxi-column>
-->

  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false"><dxo-header-filter
      [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.documentTypes, 'CreatedBy'))"></dxo-header-filter></dxi-column>
  <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false" format="dateTime"></dxi-column>
  <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true"><dxo-header-filter
      [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(this.documentTypes, 'UpdatedBy'))"></dxo-header-filter> </dxi-column>
  <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

  <dxi-column type="buttons">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
    <dxi-button text="Show Log" template="logTemplate" [visible]="allowShowLog">
    </dxi-button>
  </dxi-column>

  <ng-container *dxTemplate="let cell of 'editXPathTemplate'">
    <app-xpath [value]="cell.value" [documentTypeId]="cell.data.Id" (valueChange)="onXPathValueChange($event, cell)"></app-xpath>
  </ng-container>

  <ng-container *dxTemplate="let cell of 'logTemplate'">
    <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log for ' + cell.data.Name" [showIcon]="false" classNames="dx-link">
      <app-change-log-link-entity type="DocumentType" [id]="cell.data.Id"></app-change-log-link-entity>
    </app-change-log-link>
  </ng-container>

  <div *dxTemplate="let cellInfo of 'stylesheetCellTemplate'">
    <dx-check-box class="dx-datagrid-checkbox-size" [disabled]="true" [value]="!!cellInfo.data.CdmStylesheetArtifactId"></dx-check-box>
  </div>

  <ng-container *dxTemplate="let cellInfo of 'stylesheetEditTemplate'">
    <app-developer-artifact-xml-picker [xmlTypes]="['Xslt']" (selectedArtifactIdChange)="setArtifactId($event, cellInfo)"
      [selectedArtifactId]="cellInfo.data.CdmStylesheetArtifactId"></app-developer-artifact-xml-picker>
  </ng-container>
</dx-data-grid>
